// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"22":"663d8c41","38":"b7ffef85","91":"9d49f40f","462":"f1156abe","509":"886b8749","580":"8d8efed6","593":"8006ae2b","621":"7b4d7859"}[chunkId] + ".js";
};